module.exports = require('./globals.json');



/*****************
 ** WEBPACK FOOTER
 ** ./~/globals/index.js
 ** module id = 326
 ** module chunks = 0
 **/